let scrollPos = window.scrollY;
let header = document.querySelector("header");


// When scrolling down add a class
window.onscroll = function (e) {
    scrollPos = window.scrollY;
    if (scrollPos >= 8) {
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
}

// If page is scrolled then add classes en set position for nav.
function checkSroll() {
    if (scrollPos >= 24) {
        header.classList.add("scrolled");
    }
}

document.addEventListener("DOMContentLoaded", checkSroll);

// Hamburger toggle
///////////////////////////////////////////
// The click
$(".burger").addClass("unToggled");
$(".burger").click(function () {
    $(this).toggleClass("toggled");
    $(this).toggleClass("unToggled");
    $('.overlay-menu').addClass("overlay-menu--open");
});

$(".overlay-menu__bg").click(function () {
    $('.burger').toggleClass("unToggled");
    $('.overlay-menu').removeClass("overlay-menu--open");
});
